import React, { useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import PurchaseGiftCardForSelf from '../components/PurchaseGiftCardForSelf';
import PurchaseGiftCardForOthers from '../components/PurchaseGiftCardForOthers';
import BadgeOptions from '../components/BadgeOptions';
import { OrderingConstants, OrderingOperations, OrderingSelectors } from 'polygon-ordering';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { styled } from '@mui/system';
import { useTyro } from '../hooks/TyroProvider';
import { purchaseGiftCardClicked } from '../utils/analytics';
import history from '../history';
import { PURCHASE_GIFT_CARD_ROUTE } from '../constants/loyaltyRoutes';

const { getGatewayType } = OrderingSelectors;
const { PAYMENT_GATEWAY_TYPES } = OrderingConstants;

const BadgeOptionsWrapper = styled('div')(() => {
  return {
    '.row': {
      margin: '10px 0 1.5em',
    },
  };
});

const { fetchGiftcardSurcharge } = OrderingOperations;

const PurchaseGiftCardScreen = () => {
  const [gift, setGift] = useState(true);
  const dispatch = useAppDispatch();
  const gatewayType = useAppSelector(getGatewayType);
  const location = useLocation();
  // eslint-disable-next-line
  const tyroData = gatewayType === PAYMENT_GATEWAY_TYPES.TYRO ? useTyro() : null;
  const { resetPaySecret, setGiftCardTopUpData } =
    gatewayType === PAYMENT_GATEWAY_TYPES.TYRO && tyroData;

  const onPaymentStep = location.pathname.endsWith('/payment');

  useEffect(() => {
    dispatch(fetchGiftcardSurcharge());
    purchaseGiftCardClicked();
  }, []);

  const handleBadgeChange = (status: boolean) => {
    setGift(status);
    if (gatewayType === PAYMENT_GATEWAY_TYPES.TYRO) {
      resetPaySecret();
      setGiftCardTopUpData(null);
    }
    const fieldsRoute = status
      ? `${PURCHASE_GIFT_CARD_ROUTE}/others/fields`
      : `${PURCHASE_GIFT_CARD_ROUTE}/self/fields`;
    history.push(fieldsRoute);
  };

  if (location.pathname === PURCHASE_GIFT_CARD_ROUTE) {
    return (
      <Redirect
        to={
          gift
            ? `${PURCHASE_GIFT_CARD_ROUTE}/others/fields`
            : `${PURCHASE_GIFT_CARD_ROUTE}/self/fields`
        }
      />
    );
  }

  return (
    <div style={{ paddingTop: 32 }}>
      {!onPaymentStep && (
        <BadgeOptionsWrapper>
          <BadgeOptions
            active={gift}
            setActive={handleBadgeChange}
            activeKey="buyAsGift"
            inactiveKey="buyForMyself"
          />
        </BadgeOptionsWrapper>
      )}

      {gift ? <PurchaseGiftCardForOthers /> : <PurchaseGiftCardForSelf />}
    </div>
  );
};

export default PurchaseGiftCardScreen;
